import React from "react";

export const MSG_SIN_LOCALES = "Este negocio no tiene locales en el PDV";

/** Checkbox list of PDV locales `{ id, nombre }` with its loading, error (retry) and empty states. */
const LocalesPdv = ({ estado, locales, seleccionados, onToggle, error, onReintentar, disabled = false }) => {
  if (estado === "loading") return <p className="ef-hint">Cargando locales...</p>;
  if (estado === "error") {
    return (
      <div className="pu-row-actions">
        <span className="ef-hint" role="alert">{error}</span>
        <button type="button" className="zr-btn zr-btn--ghost" onClick={onReintentar}>Reintentar</button>
      </div>
    );
  }
  if (estado !== "ok") return null;
  if (locales.length === 0) {
    return (
      <>
        <p className="ef-hint">{MSG_SIN_LOCALES}</p>
        <p className="ef-hint">Crealos en el PDV y después asignáselos desde acá.</p>
      </>
    );
  }
  return (
    <div role="group" aria-label="Locales del PDV" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {locales.map((l) => (
        <label key={l.id} style={{ display: "flex", gap: 8, alignItems: "center", cursor: "pointer", margin: 0 }}>
          <input
            type="checkbox"
            checked={seleccionados.includes(l.id)}
            disabled={disabled}
            onChange={() => onToggle(l.id)}
            style={{ accentColor: "var(--zr-lime, #b1c20e)" }}
          />
          <span>{l.nombre}</span>
        </label>
      ))}
    </div>
  );
};

export default LocalesPdv;
